export default "__VITE_ASSET__CL2RKBD1__"